import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ScrollPositionService} from '../../services/scroll-position.service';
import {PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {Meta, Title} from '@angular/platform-browser';

declare var AOS: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor(private spService: ScrollPositionService,
              @Inject(PLATFORM_ID) private platformId: Object,
              meta: Meta,
              title: Title) {
    const metadata = {
      title: 'Gridhaus',
      description: 'Welcome to Gridhaus. We elevate brands & businesses through strategy & design made for the digital world.'
    };
    meta.addTags([
      {name: 'description', content: metadata.description},
      {name: 'twitter:card', content: 'summary_large_image'},
      {name: 'twitter:title', content: metadata.title},
      {name: 'twitter:description', content: metadata.description},
      {property: 'og:title', content: metadata.title},
      {property: 'og:description', content: metadata.description},
    ]);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    AOS.refreshHard();
    this.spService.autoScroll();
    if (isPlatformBrowser(this.platformId)) {
    }
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/home/home.component.ts